import React from 'react';
import { motion } from 'framer-motion';
import { FilmIcon, UtensilsIcon, ArrowRightIcon } from 'lucide-react';
interface PortfolioProps {
  onNavigate?: (page: 'home' | 'about' | 'business', slug?: string) => void;
}
export function Portfolio({
  onNavigate
}: PortfolioProps) {
  return <section className="bg-white py-24 md:py-32 px-6" data-id="element-257">
      <div className="max-w-7xl mx-auto" data-id="element-258">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-20 md:mb-24" data-id="element-259">
          <span className="text-[#c9a961] text-[13px] font-bold tracking-[0.2em] uppercase mb-4 block" data-id="element-260">
            Our Expertise
          </span>
          <h2 className="font-display text-[40px] md:text-[56px] font-medium text-[#1d1d1f] mb-6" data-id="element-261">
            Diverse Portfolio
          </h2>
          <div className="w-20 h-[1px] bg-[#c9a961] mx-auto mb-8" data-id="element-262" />
          <p className="text-[#86868b] text-[18px] md:text-[20px] max-w-2xl mx-auto font-light leading-relaxed" data-id="element-263">
            Two distinct ventures, one unwavering commitment to excellence and
            innovation.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-10" data-id="element-264">
          {/* J Square Filming */}
          <motion.button initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.1
        }} onClick={() => onNavigate?.('business', 'j-square-filming-thailand')} className="group relative block w-full text-left overflow-hidden" data-id="element-265">
            <div className="absolute inset-0 bg-[#1d1d1f] transform transition-transform duration-700 group-hover:scale-[1.02]" data-id="element-266" />
            <div className="relative h-full p-12 md:p-16 flex flex-col items-start z-10" data-id="element-267">
              <div className="w-16 h-16 rounded-full bg-white/10 backdrop-blur-md flex items-center justify-center mb-8 border border-white/10 group-hover:bg-[#c9a961] group-hover:border-[#c9a961] transition-all duration-500" data-id="element-268">
                <FilmIcon className="w-8 h-8 text-white" data-id="element-269" />
              </div>
              <h3 className="font-display text-[32px] text-white mb-4 group-hover:text-[#c9a961] transition-colors duration-300" data-id="element-270">
                J Square Filming
              </h3>
              <p className="text-white/70 text-[16px] leading-relaxed mb-8 max-w-md font-light" data-id="element-271">
                Premium film production services for movies and commercials.
                State-of-the-art facilities in the heart of Bangkok.
              </p>
              <span className="inline-flex items-center gap-2 text-white font-medium text-[14px] uppercase tracking-wider group-hover:gap-4 transition-all duration-300 border-b border-transparent group-hover:border-[#c9a961] pb-1" data-id="element-272">
                Discover Production{' '}
                <ArrowRightIcon className="w-4 h-4 text-[#c9a961]" data-id="element-273" />
              </span>
            </div>
            {/* Background Image Overlay */}
            <div className="absolute inset-0 opacity-20 bg-cover bg-center transition-transform duration-1000 group-hover:scale-110" style={{
            backgroundImage: "url('https://images.pexels.com/photos/66134/pexels-photo-66134.jpeg?auto=compress&cs=tinysrgb&w=800')"
          }} data-id="element-274" />
          </motion.button>

          {/* Hospitality */}
          <motion.button initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} onClick={() => {
          const el = document.getElementById('businesses');
          if (el) el.scrollIntoView({
            behavior: 'smooth'
          });
        }} className="group relative block w-full text-left overflow-hidden" data-id="element-275">
            <div className="absolute inset-0 bg-[#ebebed] transform transition-transform duration-700 group-hover:scale-[1.02]" data-id="element-276" />
            <div className="relative h-full p-12 md:p-16 flex flex-col items-start z-10" data-id="element-277">
              <div className="w-16 h-16 rounded-full bg-[#1d1d1f]/5 flex items-center justify-center mb-8 border border-[#1d1d1f]/5 group-hover:bg-[#c9a961] group-hover:border-[#c9a961] transition-all duration-500" data-id="element-278">
                <UtensilsIcon className="w-8 h-8 text-[#1d1d1f] group-hover:text-white transition-colors duration-300" data-id="element-279" />
              </div>
              <h3 className="font-display text-[32px] text-[#1d1d1f] mb-4 group-hover:text-[#c9a961] transition-colors duration-300" data-id="element-280">
                Fine Dining Collection
              </h3>
              <p className="text-[#86868b] text-[16px] leading-relaxed mb-8 max-w-md font-light" data-id="element-281">
                16 exceptional restaurants across Thailand, bringing authentic
                Indian flavors to discerning guests.
              </p>
              <span className="inline-flex items-center gap-2 text-[#1d1d1f] font-medium text-[14px] uppercase tracking-wider group-hover:gap-4 transition-all duration-300 border-b border-transparent group-hover:border-[#c9a961] pb-1" data-id="element-282">
                Explore Restaurants{' '}
                <ArrowRightIcon className="w-4 h-4 text-[#c9a961]" data-id="element-283" />
              </span>
            </div>
            {/* Background Pattern */}
            <div className="absolute inset-0 opacity-[0.03] bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]" data-id="element-284" />
          </motion.button>
        </div>
      </div>
    </section>;
}